<section class="mx-3 h-100">
    <app-toast></app-toast>
    <div class="header justify-content-between align-items-center d-flex">
        <div class="d-flex align-items-center">
            <h2 translate class="m-0">Add Time Table</h2> 
            <ng-container *ngIf="errormessage"><span class="ms-2 text_color_red">{{errormessage}}</span></ng-container>
        </div>
        <div>
            <button translate mat-raised-button class="m-2 submit_button" color="primary" type="submit" (click)="onsubmit()" [disabled]="timetableform.invalid">Save</button>
            <button translate mat-stroked-button color="primary" type="button" class="cancel_button" (click)="onExit()"> Exit </button>
        </div>
    </div>
    <div class="bg-white p-2 my-2">
        <form [formGroup]="timeslotform">
            <div class="row mt-4">
                <div class="col-lg-10 col-md-12 col-sm-12 col-xl-10 col-xxl-10">
                    <div class="row">
                <div *ngFor="let question of questions" class="mb-3 col-12 col-sm-12 col-md-6 col-lg-6 col-xl-2 col-xxl-2">
                    <app-question [question]="question" [form]="timeslotform"></app-question>
                </div>
            </div>
            </div>
                <div class="col-12 col-sm-12 col-md-12 col-lg-2 col-xl-2 col-xxl-2 d-flex align-items-center justify-content-end">
                <button translate mat-raised-button color="primary"  class="submit_button" [disabled]="timeslotform.invalid" (click)="gettimetabledata()">
                    submit
                  </button>
                </div>
            </div>
        </form>
        <div>
        </div>
        <div class="my-2">
            <mat-divider></mat-divider>
        </div>
        <div class="mt-3">
            <form [formGroup]="timetableform" (submit)="onsubmit()">
                <div formArrayName="rows">
                    <div class="row" *ngFor="let row of rows.controls; let i = index" [formGroupName]="i">
                        <div class="mb-3 col-12 col-sm-12 col-md-6 col-lg-6 col-xl-2 col-xxl-2">
                            <label translate for="shift_id-{{i}}" class="form-label">Time</label>
                            <input id="shift_id-{{i}}" class="form-control" [disabled]="true"
                                [value]="this.rows.at(i).get('start_time')?.value + '-' + this.rows.at(i).get('end_time')?.value">
                        </div>
                        <div class="mb-3 col-12 col-sm-12 col-md-6 col-lg-6 col-xl-2 col-xxl-2">
                            <label translate for="start_day-{{i}}" class="form-label">Day </label>
                            <input id="start_day-{{i}}" class="form-control" [disabled]="true"
                                [value]="this.rows.at(i).get('start_day')?.value">
                        </div>
                        <div class="mb-3 col-12 col-sm-12 col-md-6 col-lg-6 col-xl-3 col-xxl-3">
                            <label translate for="subject-{{i}}" class="form-label">Subject:</label>
                            <select id="subject-{{i}}" class="form-select" formControlName="subject"
                                (change)="onSubjectChange($event,i)">
                                <option value="">Select Subject</option>
                                <option *ngFor="let subject of timetable_subjects" [value]="subject | json">
                                    {{subject.subject_name}}</option>
                            </select>
                        </div>
                        <div class="mb-3 col-12 col-sm-12 col-md-6 col-lg-6 col-xl-3 col-xxl-3">
                            <label translate for="employee-{{i}}" class="form-label">Employee:</label>
                            <select id="employee-{{i}}" class="form-select" formControlName="employee">
                                <option value="">Select Employee</option>
                                <option *ngFor="let lecturer of employeedropdata[i] || []" [value]="lecturer | json">
                                    {{lecturer.name}}</option>
                            </select>
                        </div>
                    </div>
                </div>
                <!-- <div>
            <button mat-raised-button class="me-2" color="primary" type="submit">
                Submit
            </button>
           </div> -->
            </form>
        </div>
    </div>
</section>